import { ContentChild, Directive, ElementRef, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { MetaDirective } from './meta.directive';
import { Subscription } from 'rxjs';
import { NgModel } from '@angular/forms';
import { FieldMetaData } from '../../core/gb-api';
import { findMeta } from '../functions/meta.functions';
import AccessEnum = FieldMetaData.AccessEnum;

@Directive({
  selector: '[ngModel]'
})
export class MetaDisablerDirective implements OnInit, OnDestroy {
  @ContentChild('input', { read: ElementRef, static: false })
  inputRef: ElementRef;

  @ContentChild(NgModel, { static: false })
  control: NgModel;

  @Input()
  name: string;

  _subscription: Subscription;

  private fieldMeta: FieldMetaData;

  constructor(
    private elementRef: ElementRef,
    @Optional() private metaDirective?: MetaDirective
  ) {}

  ngOnInit(): void {
    if (!this.metaDirective) {
      return;
    }
    if (this.metaDirective.meta && this.name) {
      this.fieldMeta = findMeta(this.name, this.metaDirective.meta);
      if (this.fieldMeta) {
        this.onMetaChange();
      }
    }
    const that = this;
    this._subscription = this.metaDirective.metaChanges.subscribe((formMeta) => {
      that.fieldMeta = findMeta(that.name, formMeta);
      if (that.fieldMeta) {
        that.onMetaChange();
      }
    });
  }

  onMetaChange(): void {
    if (!this.fieldMeta || this.fieldMeta.access === AccessEnum.ALLOWED) {
      return;
    }
    const htmlElement = <HTMLElement>this.elementRef.nativeElement;
    if (this.fieldMeta.access === AccessEnum.NONE) {
      htmlElement.setAttribute('disabled', 'disabled');
    } else if (this.fieldMeta.access === AccessEnum.DEACTIVATED) {
      if (htmlElement.getAttribute('type') === 'checkbox') {
        htmlElement.parentElement.style.display = 'none';
      }
    }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
